var _rect, _rect2, _g, _rect3, _rect4, _rect5, _rect6, _g2, _path, _g3, _path2, _g4, _circle, _circle2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilepushNode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 95,
    viewBox: "0 0 118 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_937_14767)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FC8F37"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_937_14767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5556 14.8906H19.4444C19.3266 14.8906 19.2135 14.9375 19.1302 15.0208C19.0468 15.1041 19 15.2172 19 15.3351V20.6684C19 20.7863 19.0468 20.8993 19.1302 20.9827C19.2135 21.066 19.3266 21.1128 19.4444 21.1128H22.5556C22.6734 21.1128 22.7865 21.066 22.8698 20.9827C22.9532 20.8993 23 20.7863 23 20.6684V15.3351C23 15.2172 22.9532 15.1041 22.8698 15.0208C22.7865 14.9375 22.6734 14.8906 22.5556 14.8906ZM19.4444 15.3351H22.5556V19.3351H19.4444V15.3351ZM19.4444 20.6684V19.7795H22.5556V20.6684H19.4444Z",
    fill: "#FFF4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7778 20H21.2223V20.4444H20.7778V20Z",
    fill: "#FFF4F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_937_14767)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 66,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 72,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 76,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_937_14767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 56.375L59.375 56.375L59.375 55L58.625 55ZM58.625 57.2917L58.625 60.0417L59.375 60.0417L59.375 57.2917L58.625 57.2917ZM58.625 60.9583L58.625 63.7083L59.375 63.7083L59.375 60.9583L58.625 60.9583ZM58.625 64.625L58.625 66L59.375 66L59.375 64.625L58.625 64.625Z",
    fill: "#7DB9FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 57.2917L59.375 57.2917L59.375 55L58.625 55ZM58.625 58.2083L58.625 62.7917L59.375 62.7917L59.375 58.2083L58.625 58.2083ZM58.625 63.7083L58.625 66L59.375 66L59.375 63.7083L58.625 63.7083Z",
    fill: "#42CFEF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_937_14767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#42CFEF",
    strokeWidth: 0.75,
    strokeDasharray: "5 1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_937_14767)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#42CFEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.75,
    cy: 46.75,
    r: 6.75,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5628 50.6C59.5628 50.4453 59.5077 50.3129 59.3976 50.2027C59.2874 50.0926 59.155 50.0375 59.0003 50.0375C58.8456 50.0375 58.7132 50.0926 58.603 50.2027C58.4929 50.3129 58.4378 50.4453 58.4378 50.6C58.4378 50.7547 58.4929 50.8871 58.603 50.9973C58.7132 51.1074 58.8456 51.1625 59.0003 51.1625C59.155 51.1625 59.2874 51.1074 59.3976 50.9973C59.5077 50.8871 59.5628 50.7547 59.5628 50.6ZM61.0253 49.475V44.525C61.0253 44.4641 61.003 44.4113 60.9585 44.3668C60.914 44.3223 60.8612 44.3 60.8003 44.3H57.2003C57.1394 44.3 57.0866 44.3223 57.0421 44.3668C56.9976 44.4113 56.9753 44.4641 56.9753 44.525V49.475C56.9753 49.5359 56.9976 49.5887 57.0421 49.6332C57.0866 49.6777 57.1394 49.7 57.2003 49.7H60.8003C60.8612 49.7 60.914 49.6777 60.9585 49.6332C61.003 49.5887 61.0253 49.5359 61.0253 49.475ZM59.6753 43.5125C59.6753 43.4375 59.6378 43.4 59.5628 43.4H58.4378C58.3628 43.4 58.3253 43.4375 58.3253 43.5125C58.3253 43.5875 58.3628 43.625 58.4378 43.625H59.5628C59.6378 43.625 59.6753 43.5875 59.6753 43.5125ZM61.7003 43.4V50.6C61.7003 50.8438 61.6112 51.0547 61.4331 51.2328C61.255 51.4109 61.044 51.5 60.8003 51.5H57.2003C56.9565 51.5 56.7456 51.4109 56.5675 51.2328C56.3894 51.0547 56.3003 50.8438 56.3003 50.6V43.4C56.3003 43.1562 56.3894 42.9453 56.5675 42.7672C56.7456 42.5891 56.9565 42.5 57.2003 42.5H60.8003C61.044 42.5 61.255 42.5891 61.4331 42.7672C61.6112 42.9453 61.7003 43.1562 61.7003 43.4Z",
    fill: "#394353"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_937_14767",
    x: 0,
    y: 0,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_14767"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_14767"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_14767",
    result: "effect2_dropShadow_937_14767"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_14767",
    result: "effect3_dropShadow_937_14767"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_14767",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_937_14767",
    x: 0,
    y: 60,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_14767"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_14767"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_14767",
    result: "effect2_dropShadow_937_14767"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_14767",
    result: "effect3_dropShadow_937_14767"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_14767",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_937_14767",
    x: 48.2383,
    y: 47,
    width: 21.5234,
    height: 27.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_14767"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_937_14767",
    x: 50.625,
    y: 22,
    width: 16.75,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_14767"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_937_14767",
    x: 47.126,
    y: 35.125,
    width: 23.25,
    height: 23.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_937_14767"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_937_14767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(17 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilepushNode);
export default __webpack_public_path__ + "static/media/mobilepushNode.0e814fd2006f70bb33cd870bf47ae741.svg";
export { ForwardRef as ReactComponent };